import * as React from 'react'

const SvgMenu = () => (
	<svg width={61} height={36} fill="none" xmlns="http://www.w3.org/2000/svg">
		<path stroke="currentColor" strokeWidth={4} d="M0 2h35M0 12h48M0 22h61M0 34h17" />
	</svg>
)

export default SvgMenu
